import { BaseEditor, Descendant } from 'slate';
import { ReactEditor } from 'slate-react';
import { CustomElement, CustomText } from './utils/element-renderer';

// Editor instance type
declare module 'slate' {
  interface CustomTypes {
    Editor: BaseEditor & ReactEditor;
    Element: CustomElement;
    Text: CustomText;
  }
}

// Base initial value with required stop message
export const BASE_INITIAL_VALUE: Descendant[] = [
  {
    type: 'paragraph',
    children: [{ text: '' }]
  },
  {
    type: 'stop-message',
    messageText: 'Text STOP to unsubscribe',
    children: [{ text: '' }]
  }
];

// Campaign variant content type - only stores raw editor state
export interface CampaignVariantContent {
  editorState: Descendant[];
}
